<template>
  <transition name="selection-bar-slide">
    <div v-if="count > 0" class="selection-action-bar shadow-lg">
      <div class="selection-action-bar__inner">
        <span class="selection-action-bar__count">
          Đã chọn: <strong>{{ count }}</strong> hóa đơn
        </span>
        <div class="selection-action-bar__actions">
          <b-button
            variant="primary"
            size="sm"
            class="font-weight-bolder mr-2"
            :disabled="disabled"
            @click="$emit('validate')"
          >
            <i class="fas mr-1" :class="icon"></i>
            {{ label }} ({{ count }})
          </b-button>
          <b-button
            variant="secondary"
            size="sm"
            class="font-weight-bolder"
            @click="$emit('cancel')"
          >
            Hủy bỏ
          </b-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SelectionActionBar',
  props: {
    count: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Tạo hóa đơn đỏ',
    },
    icon: {
      type: String,
      default: 'fa-file-invoice-dollar',
    },
  },
};
</script>

<style scoped>
.selection-action-bar {
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  z-index: 1040;
  background-color: #ffffff;
  border: 1px solid #e4e6ef;
  border-radius: 0.5rem;
  padding: 0.75rem 1.25rem;
  min-width: 420px;
  max-width: 92vw;
}

.selection-action-bar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}

.selection-action-bar__count {
  font-size: 0.95rem;
  color: #3f4254;
  white-space: nowrap;
}

.selection-action-bar__actions {
  display: flex;
  align-items: center;
}

.selection-bar-slide-enter-active,
.selection-bar-slide-leave-active {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.selection-bar-slide-enter,
.selection-bar-slide-leave-to {
  transform: translate(-50%, 120%);
  opacity: 0;
}
</style>
